import Login from 'views/auth/Login';
import LoginMagicLink from 'views/auth/LoginMagicLink';
import Logout from 'views/auth/Logout';

export default [
  {
    type: 'unauth',
    path: '/login/:token',
    component: LoginMagicLink,
    exact: true
  },
  {
    type: 'unauth',
    path: '/login',
    component: Login,
    exact: true
  },
  {
    type: 'private',
    path: '/logout',
    component: Logout,
    exact: true
  }
];



// WEBPACK FOOTER //
// ./src/views/auth/_routes.js